// extracted by mini-css-extract-plugin
var _1 = "List-moduleList__p8DRk";
var _2 = "List-moduleloader__gzZz_";
var _3 = "List-modulescrollable__j07GY";
var _4 = "List-modulewrapper__JO8aJ";
export { _1 as "List", _2 as "loader", _3 as "scrollable", _4 as "wrapper" }
